/**
 * - Description -
 * AlertService contains all the methods that allows the webapp to make and handle alerts.
 *
 * - Usage -
 * Using AlertService
 *
 * import AlertService from '@/helpers/AlertService.js';
 */
import store from '@/store';

export default {
    name: 'AlertService',
    createAlert: createAlert,
    destroyAlert: destroyAlert,
    createAlertException: createAlertException
}

function createAlert(alertOptions) {
    let globalToastState = {
        activator: true,
        type: alertOptions.type,
        message: alertOptions.message,
    };
    store.dispatch("AppState/setGlobalToastState", globalToastState);
}

function destroyAlert() {
    let globalToastState = {
        activator: false,
        type: "",
        message: "",
    };
    store.dispatch("AppState/setGlobalToastState", globalToastState);
}

function createAlertException(text) {
    let alertOptions = {
        type: "error",
        message: text,
    };
    createAlert(alertOptions);
}